import { ImageLoaderProps } from "next/legacy/image";

export const imageLoader = ({ src, width }: ImageLoaderProps) => {
  if (src.includes("cms.vodafone.com.tr")) {
    const url = new URL(src);
    const srcWithoutHost = url.pathname;
    return `${process.env.NEXT_PUBLIC_BASE_PATH}/cdn-images${srcWithoutHost}?w=${width}`;
  }
  return `${src}?w=${width}`;
};

export const setSessionStorage = (name: string, value: any) => {
  sessionStorage.setItem(name, JSON.stringify(value));
};

export const getSessionStorage = (name: string): any => {
  const item: any = sessionStorage?.getItem(name);
  return JSON?.parse(item);
};

export const onlyNumber = (e: string) => {
  return e.replace(/[^0-9]/g, "");
};

export const formatPhone = (value: any, previousValue = "") => {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;
  if (cvLength < 4) {
    return currentValue;
  }
  if (cvLength < 7) {
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
  } else if (cvLength < 8) {
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 7)}`;
  } else if (cvLength < 9) {
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 8)}`;
  } else if (cvLength < 10) {
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 8)}-${currentValue.slice(8, 9)}`;
  } else {
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 8)}-${currentValue.slice(8, 10)}`;
  }
};

export const TariffTabName = (name: string) => {
  const tariffs: any = [
    {
      name: "WTTX",
      value: "RedBox",
    },
    {
      name: "FIBER",
      value: "Fiber",
    },
    {
      name: "ADSL",
      value: "DSL",
    },
    {
      name: "TT",
      value: "Adsl",
    },
    {
      name: "TSOL",
      value: "Fiber",
    },
    {
      name: "TSAT",
      value: "Fiber",
    },
    {
      name: "FTTH",
      value: "Fiber",
    },
    {
      name: "TTV1",
      value: "Fiber",
    },
  ];
  const findText = tariffs.find((item: any) => item.name === name);
  if (findText) {
    return findText.value;
  }
  return name;
};

export const tarifCount = (tariffGroup: any) => {
  let tariffs = 0;
  tariffGroup?.forEach((item: any) => {
    if (item?.tariffList?.length > 0) {
      tariffs += item?.tariffList?.length;
    }
  });
  return tariffs;
};

export const getTariffCardMobileColor = (
  connectionType: string,
  flags: string,
  hiddenOffer: boolean
) => {
  if (flags?.length > 0 || hiddenOffer === true) {
    return "#eb9700";
  } else {
    if (connectionType === "DSL" || connectionType === "ADSL") {
      return "#5E2750";
    } else if (connectionType === "FIBER" || connectionType === "Fiber") {
      return "#007C92";
    } else if (
      connectionType === "WTTX" ||
      connectionType === "Wttx" ||
      connectionType === "RedBox" ||
      connectionType === "REDBOX"
    ) {
      return "#e60000";
    } else {
      return "#007C92";
    }
  }
};

export const getTariffCardColor = (
  connectionType: string,
  flags: string,
  hiddenOffer: boolean
) => {
  if (flags?.length > 0 || hiddenOffer === true) {
    return "linear-gradient(145deg,rgba(175,152,65,1) 0,rgba(175,152,65,1) 51%,rgba(255,242,195,1) 100%)";
  } else {
    if (connectionType === "DSL" || connectionType === "ADSL") {
      return "linear-gradient(54.76deg, #5E2750 11.32%, #AB39AF 96.56%)";
    } else if (connectionType === "FIBER" || connectionType === "Fiber") {
      return " linear-gradient(56.43deg, #007C92 15.4%, #00B0CA 102.52%);";
    } else if (
      connectionType === "WTTX" ||
      connectionType === "Wttx" ||
      connectionType === "RedBox" ||
      connectionType === "REDBOX"
    ) {
      return "#e60000";
    } else {
      return " linear-gradient(56.43deg, #007C92 15.4%, #00B0CA 102.52%);";
    }
  }
};

export const capitalizeFirstLetter = (string: string) => {
  return string?.charAt(0).toUpperCase() + string?.slice(1).toLowerCase();
};

export const validateSerial = (e: string) => {
  let onlyLetters = /^[a-zA-Z]+$/;
  if (onlyLetters.test(e.charAt(0)) === false) {
    return e.charAt(0).replace(/[^a-zA-ZwığüşöçĞÜŞÖÇİ]/g, "");
  }
  return e.toLocaleUpperCase();
};

export const onlyLetter = (e: string) => {
  return e.replace(/[^a-zA-ZwığüşöçĞÜŞÖÇİ]/g, "");
};

export const onlyLetterWithSpace = (e: string) => {
  return e?.replaceAll(/[0-9]/g, "")?.replace(/[^a-zA-ZwığüşöçĞÜŞÖÇİ]/g, " ");
};

export const formatBirthDate = (value: string, previousValue = "") => {
  if (!value) return value;
  const currentValue = value.replaceAll(/[^0-9]/g, "");
  const cvLength = currentValue.length;
  if (Number(currentValue?.slice(0, 2)) > 31) {
    return 31;
  } else if (Number(currentValue?.slice(2, 4)) > 12) {
    return `${currentValue?.slice(0, 2)}/12`;
  }

  if (cvLength < 3) {
    return currentValue;
  }
  if (cvLength < 5) {
    return `${currentValue.slice(0, 2)}/${currentValue.slice(2, 4)}`;
  } else {
    return `${currentValue.slice(0, 2)}/${currentValue.slice(
      2,
      4
    )}/${currentValue.slice(4, 8)}`;
  }
};

export const checkLastYear = (date = "") => {
  const formatDate = date?.replaceAll("/", "");
  const thisYear = new Date().getFullYear() - 1;
  const year = Number(formatDate?.slice(4, 8));
  return year <= thisYear && year >= 1900;
};

export const checkAdult = (date = "") => {
  const formatDate = date?.replaceAll("/", "");
  const thisYear = new Date()?.getFullYear() - 1;
  const months = Number(formatDate?.slice(2, 4));
  const thisMonths = new Date()?.getMonth() + 1;
  const year = Number(formatDate?.slice(4, 8));
  const thisDay = new Date()?.getDate();
  const day = Number(formatDate?.slice(0, 2));

  if (thisYear - year === 17) {
    if (thisMonths <= months) {
      return thisDay >= day;
    } else {
      return true;
    }
  } else {
    return thisYear - year >= 18;
  }
};

export const checkTurkishId = (id: string) => {
  const value = id?.toString();
  const isEleven = /^[0-9]{11}$/.test(value);
  if (!isEleven || "0" === value?.charAt(0)) {
    return false;
  }
  let totalX = 0;
  for (let i = 0; i < 10; i++) {
    totalX += Number(value.substr(i, 1));
  }
  const isRuleX = totalX % 10 === +value.substr(10, 1);
  let totalY1 = 0;
  let totalY2 = 0;
  for (let i = 0; i < 10; i += 2) {
    totalY1 += Number(value.substr(i, 1));
  }
  for (let i = 1; i < 10; i += 2) {
    totalY2 += Number(value.substr(i, 1));
  }
  const isRuleY = (totalY1 * 7 - totalY2) % 10 === +value.substr(9, 0);
  return isRuleX && isRuleY;
};

export const emailValidation = (email: string) => {
  const re =
    /^(?!yok)(?!abc@)(?=[^@]{2,}@)[\w+%\.-]*[a-zA-Z0-9_]@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/;
  return re.test(String(email).toLowerCase());
};

export const isNameIncluded = (name = "") => {
  return name.toLowerCase().includes("redbox");
};

export const removeTL = (string: string) => {
  return string?.replace("TL", "");
};
